<template>
    <div class="background-color-white p-5 h-100">
        <h2 class="is-size-5 has-text-weight-bold m-b-30 is-hidden-mobile">{{title}}</h2>
        <div class="is-flex is-hidden-tablet">
            <h2 class="is-size-5 has-text-weight-bold is-white-space-nowrap" :class="isOpen ? 'm-b-20':''">{{title}}</h2>
            <div class="is-justify-content-right is-flex flex-grow" @click="isOpen=!isOpen">
                <b-icon v-if="isOpen" class="text-blue" size="is-medium" icon="menu-down"></b-icon>
                <b-icon v-else class="color-grey" size="is-medium" icon="menu-left"></b-icon>
            </div>
        </div>
        <template v-if="isOpen">
            <div v-if="recentFunds">
                <div v-for="(i, index) in recentFunds" :key="index">
                    <a class="is-size-7 has-text-underline" v-tooltip="'Click to see fund details'" @click="$router.push({name:'Detailedview Results',params:{id:i.ISIN, type: type, text: convertURL(getShort(i.FundBasicsName))},query:{source:`recent-${type}`}})">{{getShort(i.FundBasicsName)}}</a>
                    <div class="buttons-actions level-left py-4 is-flex-mobile">
                        <buttons :ISIN="i.ISIN" :fund-id="i.fund_id" :fund_data="i"></buttons>
                    </div>
                </div>
            </div>
            <div v-else>
                <span class="not-available"></span>
            </div>
        </template>
    </div>
</template>

<script>
import Buttons from "@/components/Buttons";
import commonMixin from "@/mixins/commonMixin";
export default {
    name: 'RecentlyHistory',
    mixins: [commonMixin],
    props: {
        title: String,
        recentFunds: Array,
        type: String,
    },
    data() {
        return {
            isOpen: true,
        }
    },
    components: {Buttons},

    

}
</script>
